import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getRewardLedger, getRewardLedgerPending } from '../../services/api';

const emptyList = () => ({
    rows: [],
    loading: true,
    error: '',
    totalPages: 1,
    total: 0,
    from: 0,
    to: 0,
});

// Single place that reads the pagination envelope – adjust here if the API shape changes.
const parseList = (response) => {
    const data = response?.data ?? {};
    const rows = Array.isArray(data) ? data : data.data || [];
    return {
        rows,
        totalPages: data.last_page || 1,
        total: data.total ?? rows.length,
        from: data.from ?? (rows.length ? 1 : 0),
        to: data.to ?? rows.length,
    };
};

export const fetchRewardLedger = createAsyncThunk(
    'rewardLedger/fetchLedger',
    async ({ perPage = 50, page = 1, filters = {} }, { rejectWithValue }) => {
        try {
            return parseList(await getRewardLedger(perPage, page, filters));
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch reward ledger');
        }
    }
);

export const fetchRewardLedgerPending = createAsyncThunk(
    'rewardLedger/fetchPending',
    async ({ perPage = 50, page = 1, filters = {} }, { rejectWithValue }) => {
        try {
            return parseList(await getRewardLedgerPending(perPage, page, filters));
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch pending reward ledger');
        }
    }
);

const rewardLedgerSlice = createSlice({
    name: 'rewardLedger',
    initialState: {
        ledger: emptyList(),
        pending: emptyList(),
    },
    reducers: {},
    extraReducers: (builder) => {
        const wire = (thunk, key) => {
            builder
                .addCase(thunk.pending, (state) => {
                    state[key].loading = true;
                    state[key].error = '';
                })
                .addCase(thunk.fulfilled, (state, action) => {
                    state[key] = { ...state[key], ...action.payload, loading: false, error: '' };
                })
                .addCase(thunk.rejected, (state, action) => {
                    state[key].rows = [];
                    state[key].error = action.payload || 'Something went wrong';
                    state[key].loading = false;
                });
        };
        wire(fetchRewardLedger, 'ledger');
        wire(fetchRewardLedgerPending, 'pending');
    },
});

export default rewardLedgerSlice.reducer;